import { render, staticRenderFns } from "./BaseMattersWrapperView.vue?vue&type=template&id=33184734&scoped=true"
import script from "./BaseMattersWrapperView.vue?vue&type=script&lang=js"
export * from "./BaseMattersWrapperView.vue?vue&type=script&lang=js"
import style0 from "./BaseMattersWrapperView.vue?vue&type=style&index=0&id=33184734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33184734",
  null
  
)

export default component.exports